import { createApiClient } from '@cortex/api-client';
import { config } from './config.ts';

// The access token lives in memory only (never in localStorage). The accounts
// integration (E1.3) sets it after sign-in and on refresh.
let accessToken: string | undefined;

export const setAccessToken = (token: string | undefined) => {
  accessToken = token;
};

/** The current access token (the chat panel sends it to the assistant service). */
export const getAccessToken = () => accessToken;

/** The API's origin (and path prefix): every client of the web app (the API's, each SDK's) calls it. */
export const apiBaseUrl = new URL(config.VITE_API_BASE_URL, window.location.origin)
  .toString()
  .replace(/\/$/, '');
const baseUrl = apiBaseUrl;

/** The only way the web app calls the API. */
export const api = createApiClient({ baseUrl, getToken: () => accessToken });

/**
 * The header an app's chat names its app with (a person may reach the project only through the app): the api's
 * APP_REACH_HEADER (@cortex/api-kit names.ts, a server package the browser does not load).
 */
export const APP_REACH_HEADER = 'x-cortex-app';
